import React from 'react';

import {LANGUAGE_MENU} from "../../language-menu-module.consts";
import classNames from "classnames";
import styles from "../../styles/language-menu.module.scss";
import {LanguageMenuModuleHeaderItems} from "./language-menu-module.header-items";
import {LanguageMenuModuleArrow} from "../language-menu-module.arrow-button";
import {LanguageMenuModuleHeaderTitle} from "./language-menu-module.header-title";

export const LanguageMenuModuleHeader = ({controller}) => {
  const {state} = controller;
  const {menuModel} = state;
  const {shouldArrowOpenMenu} = menuModel;

  const containerProps = {
    className: classNames(styles.header),
    onClick: shouldArrowOpenMenu ? (e) => {
      e.stopPropagation();
      e.preventDefault();

      controller.action(LANGUAGE_MENU.ACTION_TYPES.onMenuClick)
    } : null
  };

  return (
    <div {...containerProps}>
      <LanguageMenuModuleHeaderTitle controller={controller}/>
      <LanguageMenuModuleHeaderItems controller={controller}/>
      <LanguageMenuModuleArrow controller={controller}/>
    </div>
  )
};
